'use es6';

import Raven from 'raven-js';
export const logException = error => {
  Raven.captureException(error);
};